/**
 * Sign Up With Firebase
 */
import React, { Component } from 'react';
import Button from '@mui/material/Button';
import { connect } from 'react-redux';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Link, useParams } from 'react-router-dom'; 
import LinearProgress from '@mui/material/LinearProgress';
import QueueAnim from 'rc-queue-anim';
import CircularProgress from '@mui/material/CircularProgress';
import {decode as base64_decode} from 'base-64';
import {
	FormGroup,
	Label,
	
} from 'reactstrap';
// components
import { SessionSlider } from 'Components/Widgets';

// app config
import AppConfig from 'Constants/AppConfig';

// redux action
import {
    cocahAcceptTravel, 
} from 'Actions';

const sessionBg = require('Assets/img/tsga-banner3.jpg');


class TravelAccept extends Component {

   state = {      
      pid:'',
      userid:'',
      actionid:'',
      loader:false,
   }

    componentDidMount() {
      const { id, usrid, action } = this.props.params || {};

      if (id && usrid && action) {
         let urlid = base64_decode(id);
         let userid = base64_decode(usrid);
         let actionid = base64_decode(action);
         if (urlid != 0) {
            this.setState({
               pid: urlid,
               userid: userid,
               actionid: actionid,
            });
         }
      }
    }

    addHandleSubmit(event){
        this.setState({loader:true });  
        event.preventDefault();
        let { pid, userid,  actionid} =this.state;
        this.props.cocahAcceptTravel(event, pid, userid, actionid).then((data) => {   
            this.setState({loader:false });    
            document.getElementById("addform").reset();          
         });
     }


   render() {
      
      const { loading } = this.props;
      const styles = {
         buttonProgress: {
             color: "blue",
             position: 'absolute',
             top: '50%',
             left: '50%',
             marginTop: -15,
             marginLeft: -15,
         },
         wrapper: {
             position: 'relative',
         },
     };
      return (
         <QueueAnim type="bottom" duration={2000}>
            <div
               className="rct-session-wrapper"
               style={{ backgroundImage: `url(${sessionBg})` }}
               key="travel-accept"
            >
               {loading &&
                  <LinearProgress />
               }
               <AppBar position="static" className="session-header">
                  <Toolbar>
                     <div className="container">
                        <div className="d-flex justify-content-between">
                           <div className="session-logo">
                              <Link to="/">
                                 <img src={AppConfig.appLogo} alt="session-logo" width="110" height="35" />
                              </Link>
                           </div>
                           
                        </div>
                     </div>
                  </Toolbar>
               </AppBar>
               <div className="session-inner-wrapper">
                  <div className="container">
                     <div className="row row-eq-height">
                        <div className="col-sm-10 col-md-6 col-lg-6" style={{margin:"0 auto"}}>
                           <div className="session-body text-center">
                              <div className="session-head mb-15">
                                 {this.state.actionid==1?
                                   <h2>TRAVEL FORM ACCEPTED BY</h2>
                                  :
                                  <h2>TRAVEL FORM REJECTED BY</h2>
                                  }
                                 
                              </div>
                              <form autoComplete="off" id="addform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                                 <div className="row">
                                    
                                    <div className="col-md-12">
                                       <FormGroup>
                                          <input type="text" name="acceptname" id="acceptname" className="form-control form-control-alternative" placeholder="Please enter your name" required/>
                                       </FormGroup>
                                    </div>   
                                     
                                    {this.state.actionid==2 ?
                                    <div className="col-md-12">
                                      <FormGroup>
                                      <textarea rows="3" type="text" name="comments" id="comments" className="form-control form-control-alternative" placeholder="Reasons" required></textarea>
                                      </FormGroup>
                                   </div>  
                                    :''}
                                    <div className="col-md-12">
                                        <div className="form-group"> 
                                             <div className="sdds" style={styles.wrapper}>
                                                <button type="submit" className="mr-3 mb-3 btn btn-outline-primary btn-sm" disabled={this.state.loader}>Submit</button> 
                                                {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}
                                             </div>
                                        </div>
                                    </div>
                                 </div>
                              </form>                             
                           </div>
                        </div>                        
                     </div>
                  </div>
               </div>
            </div>
         </QueueAnim>
      );
   }
}

// map state to props
const mapStateToProps = ({ authUser }) => {
   const { loading } = authUser;
   return { loading };
};

// wrapper to inject params in class component (React Router v6)
function withRouterParams(Component) {
   return (props) => {
      const params = useParams();
      return <Component {...props} params={params} />;
   };
}

export default connect(mapStateToProps, {
    cocahAcceptTravel, 
})(withRouterParams(TravelAccept));
